module.exports = __webpack_public_path__ + "static/img/witness-teens-2.8b80ebb6.png";